/**
 * Pure routing helpers for V2 intake payment return / processing.
 * Keep free of Vue so node unit tests can load via vm.
 */

/** A gateway callback's identifiers always take precedence over browser drafts. */
export function bookingReturnIdentifiers(query = {}, draft = {}, session = {}) {
  const explicitBooking = query.bookingId || query.booking_id || ''
  const payment = query.payment_id || query.successful_payment || ''
  const cart = query.cart_id || ''
  const booking = explicitBooking || (!(payment || cart) && (draft.bookingId || session.bookingId)) || ''
  const identifiers = {}
  if (booking) identifiers.booking_id = String(booking)
  if (payment) identifiers.payment_id = String(payment)
  if (cart) identifiers.cart_id = String(cart)
  return identifiers
}

/**
 * @param {string} status
 * @param {string} [bookingId]
 * @returns {{name: string, query?: object}}
 */
export function routeForClientStatus(status, bookingId) {
  if (status === 'MANUAL_SCHEDULING_REQUIRED') return {name:'portalHome',paymentOutcome:null}
  const q = bookingId ? {bookingId} : {}
  if (status === 'CONFIRMED') {
    return {name: 'intakePaySuccess', query: q, paymentOutcome: 'success'}
  }
  if (status === 'PAYMENT_LATE') {
    return {name: 'intakePayLate', query: q, paymentOutcome: 'late'}
  }
  if (status === 'PAYMENT_FAILED' || status === 'CANCELLED') {
    return {name: 'intakePayFail', query: q, paymentOutcome: 'fail'}
  }
  return {name: 'intakePayProcessing', query: q, paymentOutcome: null}
}

/**
 * Map server booking.state during poll.
 * @param {string} state
 * @returns {{name: string, paymentOutcome: string}|null}
 */
export function routeForBookingState(state) {
  if (state === 'ADMIN_UNSCHEDULED') return {name:'portalHome',paymentOutcome:null}
  if (state === 'CONFIRMED') {
    return {name: 'intakePaySuccess', paymentOutcome: 'success'}
  }
  if (state === 'PAYMENT_LATE' || state === 'REFUND_REQUIRED') {
    return {name: 'intakePayLate', paymentOutcome: 'late'}
  }
  if (state === 'PAYMENT_FAILED' || state === 'CANCELLED') {
    return {name: 'intakePayFail', paymentOutcome: 'fail'}
  }
  return null
}

export function isTerminalBookingState(state) {
  return routeForBookingState(state) !== null
}
